import { serializable, DynamicFormControlLayout, DynamicInputModelConfig, DynamicInputModel } from '@ng-dynamic-forms/core';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI } from '../workflow-components.models';

  
export interface ToggleModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
}
  
export class ToggleModel extends DynamicInputModel {
	@serializable() readonly type: string = 'toggle';
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;
	
	constructor(config: ToggleModelConfig, layout?: DynamicFormControlLayout) {
        super(config, layout);
		this.componentMode = config.componentMode;
		this.componentUI = COMPONENT_UI.IONIC;
	}

	public static initModel(_component: Model_WorkflowComponent) {
		const formModel = new ToggleModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
            value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			relations: _component.RELATIONS,
			additional: _component
		});
		return formModel;
	}
}
  